import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { StartedConversation } from "@/types";
import PlaceholderLoading from "react-placeholder-loading";
import { Link } from "react-router-dom";

type ConversationsProps = {
  conversations: StartedConversation[] | null;
};

const ConversationPlaceholder = () => {
  return (
    <div className="flex items-center space-x-4 p-3 bg-gray-800 rounded-lg hover:bg-gray-700 transition-colors conversation-placeholder">
      <PlaceholderLoading shape="circle" width={40} height={40} />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium truncate text-gray-200">
          <PlaceholderLoading shape="rect" width={200} height={20} />
        </p>
        <p className="text-xs text-gray-400 truncate mt-1">
          <PlaceholderLoading shape="rect" width={100} height={14} />
        </p>
      </div>
      <div className="text-xs text-gray-400">
        <PlaceholderLoading shape="rect" width={50} height={16} />
      </div>
    </div>
  );
};

export function Conversations({ conversations }: ConversationsProps) {
  return (
    <div>
      <h2 className="text-xl font-bold mb-4 text-primary">
        Your Conversations
      </h2>
      <div className="space-y-2">
        {conversations === null &&
          [1, 2, 3, 4, 5].map((n) => <ConversationPlaceholder />)}
        {conversations?.length === 0 && <div>You have conversations yet</div>}
        {conversations?.map((conversation) => (
          <Link
            to={`/app/chat/${conversation.id}`}
            className="flex w-full flex-col"
          >
            <div
              key={conversation.id}
              className="flex items-center space-x-4 p-3 bg-gray-800 rounded-lg hover:bg-gray-700 transition-colors"
            >
              <Avatar>
                <AvatarImage src={conversation.image} alt={conversation.name} />
                <AvatarFallback>{conversation.name[0]}</AvatarFallback>
              </Avatar>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium truncate text-gray-200">
                  {conversation.name}
                </p>
                <p className="text-xs text-gray-400 truncate">
                  {conversation.last_message}
                </p>
              </div>
              <div className="text-xs text-gray-400">
                {new Date(conversation.last_activity).toDateString()}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
